import { Container, Typography } from '@mui/material';
import React from 'react';
import { LogsProvider } from './logsContext';
import LogsContent from './logsContent';

const LogsPage = function ({ isSuperAdmin }: { isSuperAdmin?: boolean }) {
  return (
    <Container maxWidth={false} sx={{ py: 0 }}>
      <LogsProvider>
        <LogsContent isSuperAdmin={isSuperAdmin} />
      </LogsProvider>
    </Container>
  );
}

export default React.memo(LogsPage);